import {BaseService} from "./base.service";

class ServicesService extends BaseService {

    constructor() {
        super('api/services')
    }

    getServByKind(id) {
        return this.http.get(`api/get-serv-by-kind/${id}`).then(response => response.data).catch(err => err.message);
    }

    getServiceByEvent(){
        return this.http.get(`api/get-service-by-event`).then(response => response.data).catch(err => err.message);
    }
    getServiceAll(){
        return this.http.get(`api/get-service-all`).then(response => response.data).catch(err => err.message);
    }

}

export const servicesService = new ServicesService();
